(() => {
  'use strict';

  const elementName = 'sqp-preparation-nudge';

  if (customElements.get(elementName)) return;

  const DAY_MS = 86400000;

  class SqpPreparationNudge extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;

      this._deadline = Date.parse(this.dataset.deadline);
      this._active = this.querySelector('[data-sqp-active]');
      this._expired = this.querySelector('[data-sqp-expired]');
      this._days = this.querySelector('[data-sqp-days]');
      this._label = this.querySelector('[data-sqp-day-label]');

      this._resume = () => {
        if (!document.hidden) this.updateCountdown();
      };

      document.addEventListener('visibilitychange', this._resume);
      window.addEventListener('pageshow', this._resume);

      this.updateCountdown();
    }

    disconnectedCallback() {
      window.clearTimeout(this._timer);
      this._timer = null;

      document.removeEventListener('visibilitychange', this._resume);
      window.removeEventListener('pageshow', this._resume);

      this._connected = false;
    }

    updateCountdown() {
      window.clearTimeout(this._timer);
      this._timer = null;

      if (!this.isConnected) return;

      if (
        !Number.isFinite(this._deadline) ||
        !this._active ||
        !this._expired ||
        !this._days ||
        !this._label
      ) {
        this.hidden = true;
        return;
      }

      const remaining = this._deadline - Date.now();

      if (remaining <= 0) {
        this._active.hidden = true;
        this._expired.hidden = false;
        return;
      }

      this._active.hidden = false;
      this._expired.hidden = true;

      const days = Math.ceil(remaining / DAY_MS);
      const dayText = String(days);
      const labelText = days === 1
        ? this.dataset.daySingular
        : this.dataset.dayPlural;

      // Avoid unnecessary live-region updates.
      if (this._days.textContent !== dayText) {
        this._days.textContent = dayText;
      }

      if (this._label.textContent.trim() !== labelText) {
        this._label.textContent = labelText;
      }

      // Wake at the next displayed-day boundary or within one minute.
      // Always recalculate from the fixed deadline, never decrement a counter.
      const untilNextDay = remaining - ((days - 1) * DAY_MS);
      const delay = Math.max(
        50,
        Math.min(60000, untilNextDay + 20)
      );

      this._timer = window.setTimeout(
        () => this.updateCountdown(),
        delay
      );
    }
  }

  customElements.define(elementName, SqpPreparationNudge);
})();
